module.exports = __webpack_public_path__ + "media/Slide14.1760424e.mp3";